import { render, staticRenderFns } from "./teacherPassword.vue?vue&type=template&id=da86669c&scoped=true&"
import script from "./teacherPassword.vue?vue&type=script&lang=js&"
export * from "./teacherPassword.vue?vue&type=script&lang=js&"
import style0 from "./teacherPassword.vue?vue&type=style&index=0&id=da86669c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da86669c",
  null
  
)

export default component.exports